import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { FormSettingsDetailViewTopBar } from "./TopBar"

export const formSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: FormSettingsDetailViewTopBar,
}
